<template>
  <!-- 这个是成就的页面 -->
  <div class="achievement">
    <img class="achievement_bg" :src="imgList[getTheme].achievement" alt="" />
    <!-- <img
      class="achievement_bg"
      v-if="getTheme == 1"
      src="@/img/kpachievementbg.png"
      alt
    /> -->
    <!-- <img class="achievement_bg" v-else src="@/img/achievementbg.png" alt /> -->
    <div class="achievement_box">
      <div class="achievement_nav">
        <div class="achievement_nav_url" @click="ret">
          <img
            class="achievement_nav_img"
            :src="require('@/img/' + getTheme + '-back.png')"
            alt=""
          />
          <!-- <img
            class="achievement_nav_img"
            v-if="getTheme == 1"
            src="@/img/fanhui.png"
            alt
          />
          <img
            class="achievement_nav_img"
            v-else
            src="@/img/regular-back.png"
            alt
          /> -->
        </div>
        <!-- {{$t('ME.ACHIEVEMENT')}} -->
        <div class="achievement_nav_text">
          {{ $t("achievements.achievement") }}
        </div>
      </div>
      <!-- {{completedCount}}/{{list.length}} -->
      <div class="achievement_title">
        <div class="achievement_title1">{{ completedCount }}</div>
        <div class="achievement_title2">/</div>
        <div class="achievement_title3">{{ list.length }}</div>
      </div>
      <div class="achievement_centent">
        <div class="achievement_lists">
          <!-- list -->
          <div
            class="achievement_list"
            v-for="(item, index) in list"
            :key="index"
            @click="showIntr(index)"
          >
            <div class="achievement_list_url">
              <img
                class="achievement_list_img_gray"
                v-if="item.userState.state < 1 && item.icon"
                :src="item.icon"
                alt
              />
              <img
                class="achievement_list_img"
                v-else-if="item.userState.state >= 1 && item.icon"
                :src="item.icon"
                alt
              />
              <img
                v-else
                class="achievement_list_img_gray"
                src="@/img/chekin.png"
                alt
              />
            </div>
            <div class="achievement_list_title">{{ item.name }}</div>

            <div
              class="achievement_list_button"
              v-if="item.userState.state == 1"
              @click.stop="getAchievementsReward(item.id)"
            >
              {{ $t("achievements.get_prize") }}
            </div>
            <!--  <div
              class="achievement_list_button"

              @click.stop="getReward(index)"
            >{{$t('ME.Get_prize')}}</div> -->
            <div v-if="item.userState.state == 2" class="achievement_list_time">
              {{ NewData(item.userState.rewardTime) }}
            </div>
          </div>
        </div>

        <!-- 这里显示加到到底部了 -->
        <!-- <div class="more_game">
          <div class="more_game_height1"></div>
          <div class="loading">
            <img class="loading_img" src="@/img/loading.gif" />
            <span class="loading_text">Loading more game</span>
          </div>
          <div>No more game</div>
        </div>-->
      </div>
    </div>
    <!-- 领取奖励的弹出框 -->
    <div class="pop" v-if="popaward">
      <div class="pop_bg"></div>
      <div class="award_box">
        <div class="award_box_icon">
          <!-- <img class="award_box_icon_img" src="@/img/tag_pop_ups_1.png" alt /> -->
          <!-- <img class="award_box_icon_shadow" src="@/img/shadow.png" alt /> -->
        </div>
        <!-- 奖品 -->
        <div class="award_centent">
          <div class="award_centent_list">
            <!-- <img class="award_centent_list_img" src="@/img/tga_gold.png" alt /> -->
            <span class="award_centent_list_text">+500</span>
          </div>
          <div class="award_centent_list">
            <!-- <img class="award_centent_list_img" src="@/img/tga_lightning.png" alt /> -->
            <span class="award_centent_list_text">+500</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹出框2 查看集体信息 -->
    <!-- <div class="pop" v-if="popIsIhow">
      <div class="pop_bg"></div>
      <div class="pop_box">
        <div class="pop_close" @click="close">
          <img class="pop_close_img" src="@/img/colse.png" alt />
        </div>
        <div class="pop_box_icon">
          <img
            class="pop_box_icon_img_gray"
            v-if="currentItem.Status < 1"
            :src="currentItem.ImageSrc"
            alt
          />
          <img
            class="pop_box_icon_img"
            v-if="currentItem.Status >= 1"
            :src="currentItem.ImageSrc"
            alt
          />
          <img class="pop_box_icon_shadow" src="@/img/shadow.png" alt />
        </div>

        <div class="pop_title">{{currentItem.Name}}</div>
        <div class="pop_text" v-if="currentItem.Status>0">{{currentItem.UpdateTime}}</div>
        <div class="pop_progress" v-else>{{currentItem.Progress}}</div>
        <div class="pop_introduce">{{currentItem.Remark}}</div>

        <div class="pop_button" v-if="currentItem.Status==0">{{$t('ME.No_Received')}}</div>
        <div class="pop_button2" @click="open(currentItem.ShareUrl)" v-else>{{$t('ME.SHARE')}}</div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import configs from "@/config/config.js";
export default {
  name: "",
  data() {
    return {
      currentItem: {},
      // 奖励弹出框
      popaward: false,
      // 介绍弹出框
      popIsIhow: false,
      // state 状态1是时间 状态二是不可领取 状态三是可以领取
      list: [],
      userList: "",
      getTheme: "",
      imgList: {
        khalaspay: {
          achievement: require("@/img/khalaspay-achievement-bg.png")
        },
        dark: {
          achievement: require("@/img/dark-achievement-bg.png")
        },
        lavender: {
          achievement: require("@/img/regular-achievement-bg.png")
        },
        orange: {
          achievement: require("@/img/regular-achievement-bg.png")
        },
        "night-blue": {
          achievement: require("@/img/night-blue-achievement-bg.png")
        },
        regular: {
          achievement: require("@/img/regular-achievement-bg.png")
        }
      }
    };
  },
  created() {
    this.getTheme = configs.getTheme();
  },
  watch: {
    $route(to, from) {
      if (this.$route.path == "/achievement") {
        // this._getAchievementList();
      }
    }
  },
  computed: {
    completedCount() {
      const clist = this.list.filter(l => l.userState.state >= 1);
      return clist ? clist.length : 0;
    }
  },
  methods: {
    ...mapActions("user", ["tipMessage"]),
    ...mapActions("pay", ["Coin"]),
    ...mapActions("game", ["achievements", "userAchievements", "getReward"]),
    NewData(data) {
      return configs.NewDate(data);
    },
    // 后退
    ret() {
      this.$router.go(-1);
      // if(window.TgaBridge){
      //   TgaBridge.finishPage('close')
      // }else{
      //   this.$router.go(-1);
      // }
    },
    // 点击关闭弹框
    close() {
      this.popIsIhow = false;
    },
    showIntr(idx) {
      this.popIsIhow = true;
      this.currentItem = this.list[idx];
    },
    getUserAchievements() {
      const self = this;
      this.userAchievements({
        $axios: this.$axios
      }).then(res => {
        self.userList = res.resultInfo.data[0];
      });
    },
    // 查询金币余额
    getCoin() {
      const res = this.Coin({
        $axios: this.$axios,
        appId: configs.bipAppId()
      });
    },

    // 领取任务奖励
    async getAchievementsReward(id) {
      const res = await this.getReward({
        $axios: this.$axios,
        rewardId: id,
        rewardType: 1
      });
      if (res.stateCode == 1) {
        const data = res.resultInfo.data[0];
        this._getAchievementList();
        this.getCoin();
        this.tipMessage({
          context: data.cnt + "" + this.$t(`achievements.${data.type}`)
        });
      } else {
        this.tipMessage({
          context: this.$t(`config.server`)
        });
      }
    },

    //     getReward(idx) {
    //       this.popaward = true;
    //       this.currentItem = this.list[idx];
    //
    //
    //       this.updateUserAchievement({
    //         $axios: this.$axios,
    //         achievementid: this.currentItem.Id
    //       });
    //       setTimeout(() => {
    //         this.popaward = false;
    //         this.list[idx].Status = 2;
    //       }, 1000);
    //     },
    async _getAchievementList() {
      const res = await this.achievements({
        $axios: this.$axios
      });
      if (res.stateCode == 1) {
        console.log("achievements", res);
        this.list = res.resultInfo.data;
      } else {
        this.tipMessage({
          context: this.$t(`config.server`)
        });
      }
    },
    open(url) {
      console.log(url);
      window.open(url);
    }
  },
  mounted() {
    // this.getUserAchievements()
    this._getAchievementList();
  }
};
</script>

<style scoped="scoped">
div,
img,
span {
  -moz-user-select: none; /* Firefox私有属性 */
  -webkit-user-select: none; /* WebKit内核私有属性 */
  -ms-user-select: none; /* IE私有属性(IE10及以后) */
  -khtml-user-select: none; /* KHTML内核私有属性 */
  -o-user-select: none; /* Opera私有属性 */
  user-select: none; /* CSS3属性 */
}
.achievement {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: var(--achievementBg);
}
.achievement_box {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2;
}
.achievement_bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3.91rem;
}
.achievement_nav {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.44rem;
  position: relative;
}

.achievement_nav_url {
  box-sizing: border-box;
  width: 1.2rem;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  padding-left: 0.54rem;
  display: flex;
  align-items: center;
}
.achievement_nav_img {
  width: 0.33rem;
  height: 0.54rem;
}

.achievement_nav_text {
  font-size: 0.54rem;
  color: var(--achievementNav);
}
.achievement_title {
  margin-top: 0.5rem;
  display: flex;
  height: 1rem;
  justify-content: center;
  align-items: flex-end;
  color: #222;
  font-size: 0.92rem;
  font-weight: bold;
  line-height: 0.9rem;
}

.achievement_title .achievement_title3 {
  color: #aaa;
  font-size: 0.69rem;
  line-height: 1.1;
  display: flex;
  align-items: flex-end;
}
.achievement_title .achievement_title2 {
  color: #aaa;
  font-size: 0.69rem;
  line-height: 1.3;
  display: flex;
  align-items: flex-end;
  margin: 0 0.1rem;
}
.achievement_title .achievement_title1 {
  font-size: 0.92rem;
  font-weight: bold;
  display: flex;
  align-items: flex-end;
  color: var(--achievementSumTitle);
}
.achievement_centent {
  width: 100%;
  position: absolute;
  top: 4rem;
  bottom: 0;
  height: auto;
  overflow: auto;
  border-radius: 0.48rem 0.48rem 0 0;
  padding-top: 0.37rem;
}
.achievement_lists {
  display: flex;
  flex-wrap: wrap;
  padding: 0 0.66rem;
}
.achievement_list {
  margin-right: 0.4rem;
  margin-bottom: 0.9rem;
}

.achievement_list:nth-child(3n + 3) {
  margin-right: 0rem;
}
.achievement_list_url {
  display: flex;
  justify-content: center;
}
.achievement_list_img {
  width: 2.16rem;
  height: 2.16rem;
}
.achievement_list_img_gray {
  width: 2.16rem;
  height: 2.16rem;
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}
.achievement_list_title {
  margin-top: 0.5rem;
  width: 2.8rem;
  color: var(--achievementListText);
  font-size: 0.4rem;
  text-align: center;
  overflow: hidden; /*超出的部分隐藏起来。*/
  white-space: nowrap; /*不显示的地方用省略号...代替*/
  text-overflow: ellipsis; /* 支持 IE */
}
.achievement_list_time {
  margin-top: 0.2rem;
  font-size: 0.35rem;
  color: #aaa;
  opacity: 0.3;
  height: 0.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.achievement_list_button {
  margin: 0.2rem auto 0;
  width: 2rem;
  height: 0.62rem;
  color: #fff;
  font-size: 0.35rem;
  background-image: var(--achievementListbBtn);
  border-radius: 0.31rem;
  /* border: solid 0.03rem #ffba28; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.more_game {
  box-sizing: border-box;
  font-size: 0.25rem;
  width: 100%;
  text-align: center;
  color: #000000;
  opacity: 0.3;
  background-color: white;
}
.more_game_height {
  width: 100%;
  height: 2.16rem;
  background-color: white;
}
.more_game_height1 {
  width: 100%;
  height: 0.6rem;
  background-color: white;
}
/* 页面加载 */
.loading {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.loading_img {
  width: 0.36rem;
  height: 0.36rem;
}
/* 弹出框 */
.pop {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pop_bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.5;
}

.award_box {
  position: relative;
  z-index: 2;
  width: 9.48rem;
  height: 3.86rem;
  background-color: #ffffff;
  border-radius: 0.6rem;
}
.award_box_icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  top: -0.9rem;
}
.award_box_icon_img {
  width: 1.8rem;
  height: 1.8rem;
}

.award_box_icon_shadow {
  margin-top: 0.15rem;
  width: 0.54rem;
  height: 0.08rem;
}
.award_centent {
  display: flex;
  justify-content: center;
}
.award_centent_list {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.77rem;
}
.award_centent_list_img {
  width: 0.78rem;
  height: 0.78rem;
}
.award_centent_list_text {
  font-size: 0.54rem;
  color: #ff9c00;
}

/* 弹出框2 */
.pop_box {
  width: 9.48rem;
  border-radius: 0.6rem;
  position: relative;
  background-color: #ffffff;
  z-index: 2;
  padding-top: 1.9rem;
  padding-bottom: 0.79rem;
}
.pop_box_icon {
  width: 100%;
  position: absolute;
  top: -0.9rem;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;
}
.pop_box_icon_img {
  width: 2.16rem;
  height: 2.16rem;
}
.pop_box_icon_img_gray {
  width: 2.16rem;
  height: 2.16rem;
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}
.pop_box_icon_shadow {
  margin-top: 0.15rem;
  width: 0.54rem;
  height: 0.08rem;
}
.pop_close {
  position: absolute;
  top: 0;
  right: 0;
  width: 1.3rem;
  height: 1.3rem;
  z-index: 2;
  display: flex;
  justify-content: flex-end;
  padding: 0.2rem 0.25rem 0 0;
}
.pop_close_img {
  width: 0.72rem;
  height: 0.72rem;
}
.pop_title {
  text-align: center;
  font-size: 0.54rem;

  color: #05080b;
}
.pop_text {
  text-align: center;
  font-size: 0.36rem;
  color: #05080b;
  opacity: 0.33;
  margin-top: 0.4em;
}

.pop_introduce {
  margin: 0.59rem auto 0;
  width: 8rem;
  font-size: 0.3rem;

  color: #05080b;
  display: flex;
  justify-content: center;
}
.pop_progress {
  margin: 0.86rem auto 0;
  font-size: 0.22rem;
  color: gray;
  width: 8.16rem;
  height: 0.32rem;

  display: flex;
  justify-content: center;
}
.pop_button {
  margin: 0.86rem auto 0;
  font-size: 0.42rem;
  color: #05080b;
  border-radius: 0.6rem;
  width: 8.16rem;
  height: 1.32rem;
  background-color: #ffffff;
  box-shadow: inset 0px -0.1rem 0px 0px rgba(0, 0, 0, 0.05);
  border: solid 0.02rem rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.pop_button2 {
  margin: 0.86rem auto 0;
  font-size: 0.42rem;
  color: #05080b;
  border-radius: 0.6rem;
  width: 8.16rem;
  height: 1.32rem;
  background-color: #fff34f;
  box-shadow: inset 0px -0.1rem 0px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/achievement.vue